import { Table } from "antd";

function CustomTable({
    columns,
    tableData,
    noOfrecords,
    handleTableChange,
    rowKey,
    className,
    currentPage = 1,
    currentPageLimit = 10,
    isScroll,
    ...rest
}) {
    return (
        <Table
            columns={columns}
            dataSource={tableData}
            rowKey={rowKey}
            className={className}
            onChange={handleTableChange}
            scroll={{ x: isScroll ? "max-content" : 0 }}
            pagination={{
                hideOnSinglePage: false,
                responsive: true,
                total: noOfrecords,
                defaultPageSize: currentPageLimit,
                defaultCurrent: currentPage,
                // current: currentPage,
                showSizeChanger: true,
                pageSizeOptions: [10, 20, 50],
                showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} records`,
            }}
            sticky
            {...rest}
        />
    );
}

export default CustomTable;
